<template>
<section class="m-report-page">
    <div class="m-report-portfolio">
        <h2 class="m-report__title">{{ data.title }}</h2>
        <p class="m-report__subtitle">
            Динамика ипотечного портфеля
        </p>
        <div class="m-report-portfolio__widget-wrapper">
            <div class="m-report-portfolio__widget">
                <div class="m-report-portfolio__widget--title" v-html="data.informer.title"></div>
                <div class="m-report-portfolio__widget--volume">{{ data.informer.volume }} трлн ₽</div>
                <div class="m-report-portfolio__widget--text">Прирост за год&nbsp;
                    <span :class="isPosi(data.informer.volume_year_growth)">{{ format(data.informer.volume_year_growth)
                    }}%</span>
                </div>
                <div class="m-report-portfolio__widget--text" v-if="data.informer.volume_quarter_growth">Прирост за квартал&nbsp;
                    <span :class="isPosi(data.informer.volume_quarter_growth)">{{
                        format(data.informer.volume_quarter_growth)
                    }}%</span>
                </div>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.9999 18.84H0.0551758V20.6959H31.9999V18.84Z" fill="#DEDEDE" />
                    <path
                        d="M0.0551758 31.9999H2.0236V29.8628H13.2155V22.5518H0.0551758V31.9999ZM2.0236 24.4077H11.2471V28.0069H2.0236V24.4077Z"
                        fill="#DEDEDE" />
                    <path
                        d="M15.0735 29.8629H22.4973V32H24.5219V29.8629H31.9457V22.5519H15.0735V29.8629ZM24.5219 24.4078H30.0335V28.0071H24.5219V24.4078ZM17.0419 24.4078H22.4973V28.0071H17.0419V24.4078Z"
                        fill="#DEDEDE" />
                    <path d="M16.9845 0H9.44824V16.9278H16.9845V0ZM15.0161 15.0719H11.4167V1.91211H15.0161V15.0719Z"
                        fill="#DEDEDE" />
                    <path
                        d="M20.8649 5.6801L24.4643 1.91211V16.984H26.4327V5.6801L29.9759 1.91211V16.984H31.9443V0H29.1885L26.4327 2.92441V0H23.6769L18.8965 4.94899V16.984H20.8649V5.6801Z"
                        fill="#DEDEDE" />
                    <path
                        d="M5.56783 16.984H7.53625V15.1282V0H4.78046L0 4.94899V15.0719V16.9278H1.96842H5.56783V16.984ZM2.02466 5.6801L5.62407 1.91211V15.0719H2.02466V5.6801Z"
                        fill="#DEDEDE" />
                </svg>
            </div>
            <div class="m-report-portfolio__chart">
                <div class="m-report-portfolio__chart--graph">
                    <bar-chart-portfolio :data="data.chart.items" :sources="data.sources"></bar-chart-portfolio>

                </div>
                <div class="m-report-portfolio__chart--block">
                    <div class="m-report-portfolio__chart--wrapper">
                        <p class="m-report-portfolio__chart--text">Возможные расхождения приростов портфеля объясняются
                            округлением данных</p>
                        <p class="m-report-portfolio__chart--text" v-if="data?.sources">{{ data.sources }}</p>
                    </div>
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M31.9999 18.84H0.0551758V20.6959H31.9999V18.84Z" fill="#DEDEDE" />
                        <path
                            d="M0.0551758 31.9999H2.0236V29.8628H13.2155V22.5518H0.0551758V31.9999ZM2.0236 24.4077H11.2471V28.0069H2.0236V24.4077Z"
                            fill="#DEDEDE" />
                        <path
                            d="M15.0735 29.8629H22.4973V32H24.5219V29.8629H31.9457V22.5519H15.0735V29.8629ZM24.5219 24.4078H30.0335V28.0071H24.5219V24.4078ZM17.0419 24.4078H22.4973V28.0071H17.0419V24.4078Z"
                            fill="#DEDEDE" />
                        <path d="M16.9845 0H9.44824V16.9278H16.9845V0ZM15.0161 15.0719H11.4167V1.91211H15.0161V15.0719Z"
                            fill="#DEDEDE" />
                        <path
                            d="M20.8649 5.6801L24.4643 1.91211V16.984H26.4327V5.6801L29.9759 1.91211V16.984H31.9443V0H29.1885L26.4327 2.92441V0H23.6769L18.8965 4.94899V16.984H20.8649V5.6801Z"
                            fill="#DEDEDE" />
                        <path
                            d="M5.56783 16.984H7.53625V15.1282V0H4.78046L0 4.94899V15.0719V16.9278H1.96842H5.56783V16.984ZM2.02466 5.6801L5.62407 1.91211V15.0719H2.02466V5.6801Z"
                            fill="#DEDEDE" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="m-report-portfolio__btn">
            <a class="m-report__btn m-report__btn--primary m-report__btn--icon-left" :href="file.src"
                :title="file.original_name" :download="file.original_name">
                <svg class="m-report__btn-svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12 1.5C12.5523 1.5 13 1.94772 13 2.5L13 12.1771L15.8271 9.3508C16.2177 8.96033 16.8508 8.96041 17.2413 9.35099C17.6318 9.74157 17.6317 10.3747 17.2411 10.7652L12.707 15.2981C12.3165 15.6885 11.6835 15.6885 11.293 15.2981L6.75889 10.7652C6.36832 10.3747 6.36824 9.74157 6.75871 9.35099C7.14918 8.96041 7.78235 8.96033 8.17292 9.3508L11 12.1771L11 2.5C11 1.94772 11.4477 1.5 12 1.5ZM3 15C3.55228 15 4 15.4477 4 16V21L20 21L20 16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16L22 21.25C22 21.7436 21.7853 22.1974 21.4361 22.5175C21.0898 22.8349 20.6373 23 20.1818 23L3.81818 23C3.36269 23 2.91023 22.8349 2.56392 22.5175C2.21469 22.1974 2 21.7436 2 21.25L2 16C2 15.4477 2.44772 15 3 15Z"
                        fill="white" />
                </svg>
                <span class="m-report__btn-txt">
                    Скачать весь отчет
                </span>
            </a>
        </div>
    </div>
</section>
</template>

<script>
import BarChartPortfolio from './BarChartPortfolio.vue'
export default {
    name: 'MortgagePortfolio',
    components: { BarChartPortfolio },
    props: {
        data: {
            type: Object,
        },
        file: {
            type: Object,
        }
    },
    methods: {
        format(val) {
            if (Number(val) > 0) {
                return `+${val}`;
            } else return val;
        },

        isPosi(val) {
            if (Number(val) > 0) {
                return 'green'
            } else if (Number(val) < 0) {
                return 'red'
            } else return 'grey';
        }
    },

}
</script>